<template>
  <div>
    <app-history
      @clicked="
        showDialog = true;
        currentFood = JSON.parse(JSON.stringify(initFood));
        image = null;
      "
      title="افزودن  وعده غذایی"
    />

    <div>
      <v-data-table
        :items="foods"
        :headers="foodsHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn class="dialogButton" rounded @click="editItem(item)"
            >ویرایش</v-btn
          >
          <v-btn class="dialogButton" rounded @click="removeItem(item)"
            >حذف</v-btn
          >
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="showDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> نام</v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field v-model="currentFood.name"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> توضیحات </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-textarea
            outlined
            v-model="currentFood.description"
            no-resize
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تصویر پیوست</v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-file-input accept="image/*" v-model="image"></v-file-input>
        </v-col>
        <v-col
          v-if="currentFood.fileKey != '' || this.image != null"
          class="d-flex"
        >
          <img download :src="downloadUrl" class="imageClass" />
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="applyRequest"
          :disabled="apiRunning"
        >
          ذخیره
        </v-btn>
        <v-btn
          class="dialogButton"
          rounded
          @click="
            showDialog = false;
            isEdit = false;
          "
        >
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetBranchFoods, SaveFood, DeleteFood } from "@/api/foods";

export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showDialog: false,
      foods: [],
      currentFood: {},
      initFood: {
        name: "",
        description: "",
        id: "0",
        fileKey: "",
      },
      image: null,

      isEdit: false,

      foodsHeaders: [
        {
          text: "نام",
          value: "name",
          width: "50%",
        },

        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  created() {
    this.currentFood = JSON.parse(JSON.stringify(this.initFood));
    if (this.currentBranch) this.GetBranchFoods();
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    downloadUrl() {
      if (this.image != null) {
        return URL.createObjectURL(this.image);
      } else
        return (
          process.env.VUE_APP_API_ENDPOINT +
          "/api/File/GetFile?Key=" +
          this.currentFood.fileKey
        );
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
  },

  methods: {
    /**
     * expand khorooj
     */
    GetBranchFoods() {
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetBranchFoods(this.currentBranch.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.foods = response.data.items;

            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    downloadFile() {
      downloadFile(this.currentFood.fileKey);
    },
    editItem(item) {
      this.currentFood = Object.assign({}, item);
      this.showDialog = true;
      this.isEdit = true;
      this.image = null;
    },
    removeItem(item) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", item.id);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این غذا هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },

    applyRequest() {
      var text = "";

      if (this.currentFood.name == "") {
        text = "نام بایستی انتخاب شود.";
      }
      //  else if (this.image == null && this.currentFood.fileKey == "") {
      //   text = "تصویر بایستی انتخاب شود.";
      // }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        SaveFood(
          this.currentFood.id,
          this.currentBranch.id,
          this.currentFood.name,
          this.currentFood.description,
          this.image
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);
            this.$store.commit("SET_API_RUNNING", false);
            this.showDialog = false;
            this.GetBranchFoods();
          })
          .catch((error) => {
            this.$store.commit("SET_API_RUNNING", false);
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },

    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        DeleteFood(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);

            if (data.success) {
              this.GetBranchFoods();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>
<style scoped>
.imageClass {
  width: 60%;
  margin-right: 20%;
}
</style>
